export default {
  options: [
    { name: 'Fumigated After Plastic Wrap', id: 10 },
    { name: 'Fumigated Before Plastic Wrap', id: 20 },
    { name: 'No Plastic Wrap', id: 30 }
  ]
};
